import React, { createContext, useContext, useMemo, useState } from 'react';
import { copy } from './copy';

const STORAGE_KEY = 'mimic_lang';

const I18nContext = createContext(null);

function getInitialLang() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'ko' || saved === 'en') return saved;
  } catch (_) {
    // ignore
  }
  return 'ko';
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = (next) => {
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (_) {
      // ignore
    }
  };

  const value = useMemo(() => {
    const t = copy[lang] ?? copy.ko;
    return {
      lang,
      setLang,
      t,
      isKo: lang === 'ko',
      isEn: lang === 'en',
    };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}


